"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_slick_1 = __importDefault(require("react-slick"));
var Slider = function (props) {
    return (react_1.default.createElement(react_slick_1.default, __assign({ dots: true, arrows: false, swipeToSlide: true }, props, { responsive: exports.breakpoints[props.type] }), props.children));
};
var SSlider = (0, styled_components_1.default)(Slider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .slick-track {\n    display: flex;\n    white-space: normal;\n  }\n\n  .slick-slide {\n    display: flex !important;\n    height: auto;\n  }\n\n  .slick-slide > div {\n    width: 100%;\n  }\n\n  .slick-dots {\n    bottom: -40px;\n\n    li {\n      width: auto;\n    }\n\n    button {\n      box-sizing: content-box;\n      width: 8px;\n      height: 8px;\n      padding: 4px;\n      transition: 0.3s;\n\n      &:hover {\n        width: 40px;\n\n        &:before {\n          height: 8px;\n          width: 40px;\n          border-radius: 90px;\n        }\n      }\n\n      &::before {\n        position: absolute;\n        left: 4px;\n        top: 4px;\n        opacity: 1;\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        padding: 0px;\n        transition: 0.3s;\n        content: '';\n      }\n    }\n\n    .slick-active button {\n      width: 40px;\n\n      &::before {\n        width: 40px;\n        height: 8px;\n        background: #3cb868;\n        border-radius: 90px;\n      }\n    }\n  }\n"], ["\n  .slick-track {\n    display: flex;\n    white-space: normal;\n  }\n\n  .slick-slide {\n    display: flex !important;\n    height: auto;\n  }\n\n  .slick-slide > div {\n    width: 100%;\n  }\n\n  .slick-dots {\n    bottom: -40px;\n\n    li {\n      width: auto;\n    }\n\n    button {\n      box-sizing: content-box;\n      width: 8px;\n      height: 8px;\n      padding: 4px;\n      transition: 0.3s;\n\n      &:hover {\n        width: 40px;\n\n        &:before {\n          height: 8px;\n          width: 40px;\n          border-radius: 90px;\n        }\n      }\n\n      &::before {\n        position: absolute;\n        left: 4px;\n        top: 4px;\n        opacity: 1;\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        padding: 0px;\n        transition: 0.3s;\n        content: '';\n      }\n    }\n\n    .slick-active button {\n      width: 40px;\n\n      &::before {\n        width: 40px;\n        height: 8px;\n        background: #3cb868;\n        border-radius: 90px;\n      }\n    }\n  }\n"])));
exports.breakpoints = {
    examples: [
        {
            breakpoint: 4000,
            settings: {
                slidesToShow: 5,
            },
        },
        {
            breakpoint: 1250,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 500,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                dots: false,
            },
        },
    ],
    reviews: [
        {
            breakpoint: 4000,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
    whatElse: [
        {
            breakpoint: 4000,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 390,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
    trusted: [
        {
            breakpoint: 4000,
            settings: {
                slidesToShow: 5,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 390,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};
exports.default = SSlider;
var templateObject_1;
